import Pagination from '@/components/helpers/Pagination'

const paginationMixin = {
  components: {
    Pagination
  },
  data: function() {
    return {
      pagination: {
        page: 1,
        perPage: 25
      },
      sorting: {
        sortBy: 'id',
        desc: true
      }
    }
  },
  computed: {
    // todo: split into pagination & order query params
    paginationQueryParams() {
      return {
        page: this.pagination.page,
        per_page: this.pagination.perPage,
        order_by: this.sorting.sortBy,
        order: this.sorting.desc === undefined ? undefined : this.sorting.desc ? 'desc' : 'asc'
      }
    }
  },
  watch: {
    sorting: {
      handler () {
        this.resetPagination()
      },
      deep: true
    },
    'pagination.page': function () {
      this.scrollToTop()
      this.onPaginationUpdate()
    }
  },
  methods: {
    onPaginationUpdate() {
       // on pagination change
    },
    resetPagination() {
      this.scrollToTop()
      if (this.pagination.page === 1) {
        this.onPaginationUpdate()
        return
      }
      this.pagination.page = 1
    },
    scrollToTop() {
      window.scrollTo(0, 0)
    }
  }
}

export default paginationMixin
